import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p className={`text-xs md:text-sm uppercase tracking-[0.25em] font-medium ${light ? "text-terracotta-light" : "text-terracotta"}`}>
    {children}
  </p>
);

export const SectionHeading = ({ overline, title, light = false, className = "" }) => (
  <Reveal className={className}>
    <Overline light={light}>{overline}</Overline>
    <h2 className={`mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-none tracking-tight ${light ? "text-cream" : "text-charred"}`}>
      {title}
    </h2>
  </Reveal>
);
